import PerfectScrollbar from "perfect-scrollbar";

let PluginScrollbar = new (function () {
  let me = this;

  this.init = function (obj) {
    obj.find("[data-plugin-scrollbar]").each(function () {
      if ($(this)[0]) {
        new PerfectScrollbar($(this)[0]);
      }
    });
  };
})();

export default PluginScrollbar;
